import './index.css'
import { Controller as BaseController } from 'stimulus'
import { useDispatch } from 'stimulus-use'
import Rails from '@rails/ujs'

export class Controller extends BaseController {
  static targets = [
    'flyout',
    'loadingFlyout'
  ]

  static values = {
    flyoutRemote: Boolean
  }

  connect() {
    useDispatch(this)
  }

  isDefined(value) {
    return value !== undefined && value !== null
  }

  loadFlyout(event) {
    const reportId = event.detail.reportId
    const scheduleId = event.detail.scheduleId

    if (this.isDefined(reportId)) {
      let url = `/reports/${reportId}/schedules/new`

      if (this.isDefined(scheduleId)) {
        url = `/reports/${reportId}/schedules/${scheduleId}/edit`
      }

      this.dispatch('toggle-loading-flyout')
      const deparamData = { flyout_args: { remote: (this.hasFlyoutRemoteValue ? this.flyoutRemoteValue : false) } }
      const data = $.param(deparamData)
      Rails.ajax({
        type: 'GET',
        url: url,
        dataType: 'html',
        data: data,
        success: (response) => {
          this.flyoutTarget.innerHTML = response.body.innerHTML
          this.dispatch('toggle-flyout')
          this.dispatch('toggle-loading-flyout')
        },
        error: () => {
          alert('An error occurred. Please refresh the page and try again.')
        }
      })
    }
  }
}
